export class Rne {
    constructor(
        public value?: string,
        public label?: string,
        public typeEtabCode?: string,
        public codePostal?: string,
        public codeInsee?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/rne.model.ts